import styled from "styled-components";
import { COLOR_ADEGA_BLUE, spacing } from "../../config";

export const Container = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    flex-direction: column;

    & > svg {
        z-index: 30;
        color: ${COLOR_ADEGA_BLUE};
        width: 50px;
        position: fixed;
        top: 0;
        
       }

`;

export const LoadingAnimation = styled.img`
  height: 100%;

`;
